import React from 'react'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <nav className="navigation-wrapper">
        <div className="navigation-container">
          <a href="/">
            <div
              aria-label="Panda Demolition Homepage"
              className="navigation-logo-link"
            >
              <div className="navigation-logo-content">
                <img
                  src="/images/logo.png"
                  alt="Panda Demolition & Disposal"
                  className="navigation-logo-img"
                />
              </div>
            </div>
          </a>
          <div className="navigation-desktop-menu">
            <ul className="navigation-links-list">
              <li>
                <a href="/dumpster-rental">
                  <div className="navigation-link">
                    <span>Dumpster Rental</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="/services">
                  <div className="navigation-link">
                    <span>Services</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="/about-us">
                  <div className="navigation-link">
                    <span>About Us</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="/contact">
                  <div className="navigation-link">
                    <span>Contact</span>
                  </div>
                </a>
              </li>
            </ul>
            <button onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/auth/login/')} className="navigation-call-link navigation-btn-reset">
              <div className="navigation-cta btn btn-sm btn-secondary">
                <svg fill="none" width="18" xmlns="http://www.w3.org/2000/svg" height="18" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                <span>Customer Portal</span>
              </div>
            </button>
            <button onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/book/')} className="navigation-btn-reset">
              <div className="navigation-cta btn-primary btn btn-sm">
                <span>Book Now</span>
                <svg fill="none" width="18" xmlns="http://www.w3.org/2000/svg" height="18" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14m-7-7l7 7l-7 7"></path>
                </svg>
              </div>
            </button>
          </div>
          <button
            id="navigationMobileToggle"
            aria-label="Open Menu"
            aria-expanded="false"
            className="navigation-mobile-toggle"
          >
            <svg
              fill="none"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </div>
      </nav>
      <div id="navigationMobileOverlay" className="navigation-mobile-overlay">
        <div className="navigation-overlay-header">
          <a href="/">
            <div className="navigation-logo-link">
              <div className="navigation-logo-content">
                <img
                  src="/images/logo.png"
                  alt="Panda Demolition & Disposal"
                  className="navigation-logo-img"
                />
              </div>
            </div>
          </a>
          <button
            id="navigationCloseOverlay"
            aria-label="Close Menu"
            className="navigation-close-btn"
          >
            <svg
              fill="none"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6L6 18M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        <div className="navigation-overlay-content">
          <ul className="navigation-mobile-links">
            <li>
              <a href="/dumpster-rental">
                <div className="navigation-mobile-link">
                  <span>Dumpster Rental</span>
                </div>
              </a>
            </li>
            <li>
              <a href="/services">
                <div className="navigation-mobile-link">
                  <span>Services</span>
                </div>
              </a>
            </li>
            <li>
              <a href="/about-us">
                <div className="navigation-mobile-link">
                  <span>About Us</span>
                </div>
              </a>
            </li>
            <li>
              <a href="/contact">
                <div className="navigation-mobile-link">
                  <span>Contact</span>
                </div>
              </a>
            </li>
            <li>
              <button onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/auth/login/')} className="navigation-btn-reset navigation-mobile-btn-full">
                <div className="navigation-mobile-link navigation-mobile-link-accent">
                  <span>Customer Portal</span>
                </div>
              </button>
            </li>
          </ul>
          <div className="navigation-overlay-footer">
            <a href="tel:+19544081674">
              <div className="btn-lg btn btn-secondary navigation-full-btn">
                <span>Call Now</span>
              </div>
            </a>
            <button onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/book/')} className="navigation-btn-reset navigation-mobile-btn-full">
              <div className="btn-lg btn btn-primary navigation-full-btn">
                <span>Book Now</span>
              </div>
            </button>
          </div>
        </div>
      </div>
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.navigation-link::after, .navigation-mobile-overlay, .navigation-mobile-link {
  transition: none !important;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <dialog id="iframe-modal" className="iframe-modal">
        <div className="iframe-modal-wrapper">
          <button id="iframe-modal-close" className="iframe-modal-close" aria-label="Close">&times;</button>
          <div id="iframe-modal-loader" className="iframe-modal-loader">
            <div className="iframe-modal-spinner"></div>
            <span>Loading...</span>
          </div>
          <iframe id="iframe-modal-frame" className="iframe-modal-frame" title="Panda Portal" src="about:blank"></iframe>
        </div>
      </dialog>
      <div className="navigation-container4">
        <div className="navigation-container5">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
  const mobileToggle = document.getElementById('navigationMobileToggle');
  const mobileOverlay = document.getElementById('navigationMobileOverlay');
  const closeBtn = document.getElementById('navigationCloseOverlay');
  const overlayLinks = document.querySelectorAll('.navigation-mobile-link');

  const openMenu = () => {
    mobileOverlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    mobileToggle.setAttribute('aria-expanded', 'true');
  };

  const closeMenu = () => {
    mobileOverlay.style.display = 'none';
    document.body.style.overflow = '';
    mobileToggle.setAttribute('aria-expanded', 'false');
  };

  mobileToggle.addEventListener('click', openMenu);
  closeBtn.addEventListener('click', closeMenu);

  overlayLinks.forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileOverlay.style.display === 'flex') {
      closeMenu();
    }
  });

  mobileOverlay.addEventListener('click', (e) => {
    if (e.target === mobileOverlay) {
      closeMenu();
    }
  });

  // Global iframe modal
  const iframeModal = document.getElementById('iframe-modal');
  const iframeFrame = document.getElementById('iframe-modal-frame');
  const iframeCloseBtn = document.getElementById('iframe-modal-close');
  const iframeLoader = document.getElementById('iframe-modal-loader');

  window.openIframeModal = function(url) {
    closeMenu();
    iframeLoader.style.display = 'flex';
    iframeFrame.style.display = 'none';
    iframeFrame.src = url;
    iframeModal.showModal();
    document.body.style.overflow = 'hidden';

    iframeFrame.onload = function() {
      iframeLoader.style.display = 'none';
      iframeFrame.style.display = 'block';
    };
  };

  function closeIframeModal() {
    iframeModal.close();
    iframeFrame.src = 'about:blank';
    document.body.style.overflow = '';
  }

  iframeCloseBtn.addEventListener('click', closeIframeModal);
  iframeModal.addEventListener('click', (e) => {
    if (e.target === iframeModal) closeIframeModal();
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
